import { BulkActionButtonComponent } from 'commons/components/bulk-action-button/bulk-action-button.component';
import { useTranslation } from 'core/i18n';

export interface BulkEditPredefinedCommentComponentProps {
    onClick: VoidFunction;
}

export const BulkEditPredefinedCommentComponent: React.FC<BulkEditPredefinedCommentComponentProps> = (props) => {
    const { t } = useTranslation();
    const { onClick } = props;

    return (
        <BulkActionButtonComponent
            text={t('settings.devices.predefined-comments.list.actions.edit')}
            iconName="write"
            onClick={onClick}
        />
    );
};
